/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Exception thrown by functions within the app reducer to indicate that an
 * error has occurred. The exception contains a message that should be displayed
 * to users in a toast.
 */
export class ServiceAppError extends Error {
  /**
   * Message to display in an error toast.
   */
  displayMessage: string;

  /**
   * Constructs a new ServiceAppError.
   *
   * @param displayMessage Message to display to users in an error toast
   * @param args Any other arguments. These are passed directly to the Error
   *    constructor
   */
  constructor(displayMessage: string, ...args: any[]) {
    super(...args);
    this.displayMessage = displayMessage;
  }
}

export class ServiceParseError extends Error {
  /**
   * Message to put into decodeError.
   */
  message: string;

  /**
   * Constructs a new ServiceParseError.
   *
   * @param message Message to put into decodeError.
   * @param args Any other arguments. These are passed directly to the Error
   *    constructor
   */
  constructor(message: string, ...args: any[]) {
    super(...args);
    this.message = message;
  }
}

export class UnknownActionError extends Error {}
